import { render, staticRenderFns } from "./RegisterJoinRequest.vue?vue&type=template&id=2f5b2112&"
import script from "./RegisterJoinRequest.vue?vue&type=script&lang=js&"
export * from "./RegisterJoinRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports